var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UiButton", {
    staticClass: "mb-4 shadow-md",
    attrs: {
      processing: _vm.processing,
      buttonText: "Remove access",
      variant: "black",
      fullWidth: true,
      buttonClasses: "customButtonCard",
    },
    on: { click: _vm.removeAccess },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }